// Module
var code = "<div class=\"editing-confirmation hide\">\n\t<span class=\"confirmation-icon confirm-yes ss-gizmo ss-check\"></span>\n    <%- message %>\n    <span class=\"confirmation-icon confirm-no ss-gizmo ss-delete\"></span>\n</div>";
// Exports
module.exports = code;